module.exports = __webpack_public_path__ + "static/media/8-ValidaciondeEntrega.82a3c0b7.jpg";